import React from 'react';

import iconUnderConstruction from '../../assets/images/icon_under_construction.svg';

const UnderConstruction = () => {
    return (
            <div className="container_under-construction">
                <div className="content_under-construction">
                    <img src={iconUnderConstruction} alt="Under Construction" />
                    <div className="title">This page is currently unavailable</div>
                    <div className="subtitle">
                        We're doing some maintenance on this feature to give you a better banking experience. Try again later.
                    </div>
                </div>
            </div>
    );
};

export default UnderConstruction;
